import { useStore } from '@nanostores/react';
import { useState } from 'react';
import { chatId } from '~/lib/persistence/useChatHistory';
import { FunnelEditor } from './FunnelEditor';
import { FunnelsList } from './FunnelsList';

/**
 * Owner-facing Funnels plugin panel: the funnel list, and per funnel its
 * steps, offers, status and stats. The app id IS the chat id.
 */
export function FunnelsPanel() {
  const appId = useStore(chatId);

  return (
    <div className="relative flex h-full flex-col">
      <div className="border-b border-hairline px-4 py-3.5">
        <div className="flex items-center gap-2.5">
          <div className="flex h-6 w-6 items-center justify-center rounded-md bg-accent/10 ring-1 ring-inset ring-accent/15">
            <div className="i-ph:funnel text-[13px] text-accent" />
          </div>
          <h3 className="text-[13px] font-medium tracking-tight text-primary">Funnels</h3>
        </div>
        <p className="mt-2 text-[11px] leading-relaxed text-muted">
          Step-by-step sales flows: landing, opt-in, checkout with order bumps, upsells, thank-you.
        </p>
      </div>

      {appId ? (
        <FunnelsPanelBody key={appId} appId={appId} />
      ) : (
        <div className="flex flex-1 items-center justify-center px-6 text-center text-[12px] text-muted">
          Start building to create a funnel.
        </div>
      )}
    </div>
  );
}

function FunnelsPanelBody({ appId }: { appId: string }) {
  const [openId, setOpenId] = useState<string | null>(null);
  const [listVersion, setListVersion] = useState(0);

  return (
    <div className="flex-1 space-y-6 overflow-y-auto p-4">
      {openId ? (
        <FunnelEditor
          appId={appId}
          funnelId={openId}
          onBack={() => {
            setOpenId(null);
            setListVersion((v) => v + 1);
          }}
        />
      ) : (
        <FunnelsList key={listVersion} appId={appId} onOpen={setOpenId} />
      )}
    </div>
  );
}
